namespace $.$$ {

	const { hsla } = $mol_style_func
	
	$mol_style_define( $shm_hitalama_method_runtime_view, {
		
		height: '100%',
		minHeight: 0,
		overflow: 'hidden',
		
		Source_page: {
			height: '100%',
			maxHeight: '100%',
			minHeight: 0,
			width: '48rem',
			minWidth: '18rem',
			maxWidth: '48rem',
			overflow: 'hidden',
			flex: {
				grow: 0,
				shrink: 0,
				basis: '48rem',
			},
			Body: {
				minHeight: 0,
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
			},
			Body_content: {
				minHeight: '100%',
			},
		},
		
		Methods_page: {
			minHeight: 0,
			minWidth: '16rem',
			overflow: 'hidden',
			flex: {
				grow: 0,
				shrink: 0,
				basis: '16rem',
			},
		},
		
		Preview_page: {
			minHeight: 0,
			minWidth: '18rem',
			flex: {
				grow: 1,
				shrink: 1,
				basis: '24rem',
			},
		},

		Preview_fullscreen: {
			position: 'fixed',
			top: $mol_gap.block,
			right: $mol_gap.block,
			zIndex: 8,
			background: {
				color: $mol_theme.card,
			},
			box: {
				shadow: [[ 0, 0, `.5rem`, 0, hsla( 0, 0, 0, .25 ) ]],
			},
			border: {
				radius: $mol_gap.round,
			},
		},
		
		Source: {
			width: '100%',
			minHeight: '100%',
			flex: {
				grow: 1,
				shrink: 0,
				basis: 'auto',
			},
		},
		
		Result: {
			width: '100%',
		},

		'@': {
			shm_hitalama_method_runtime_view_fullscreen: {
				'true': {
					Source_page: {
						display: 'none',
					},
					Methods_page: {
						display: 'none',
					},
					Preview_page: {
						position: 'fixed',
						inset: '0',
						zIndex: 7,
						width: '100%',
						height: '100%',
						maxHeight: '100%',
						background: {
							color: $mol_theme.back,
						},
						overflow: 'auto',
						flex: {
							grow: 1,
							shrink: 1,
							basis: '100%',
						},
						Body: {
							minHeight: 0,
							flex: {
								grow: 1,
								shrink: 1,
								basis: 0,
							},
						},
						Body_content: {
							minHeight: 0,
						},
					},
					Result: {
						width: '100%',
					},
				},
			},
		},
		
	} )

	$mol_style_define( $shm_hitalama_method_runtime_view_methods, {

		Menu: {
			minHeight: 0,
			minWidth: '16rem',
			overflow: 'hidden',
			Body: {
				minHeight: 0,
			},
			Body_content: {
				minHeight: 0,
			},
		},

		Menu_link: {
			width: '100%',
			justifyContent: 'flex-start',
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Method_item: {
			width: '100%',
			border: {
				radius: $mol_gap.round,
			},
			'@': {
				shm_hitalama_method_runtime_view_method_view: {
					'true': {
						background: {
							color: $mol_theme.card,
						},
					},
				},
			},
		},

		Method_focus: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

	} )
	
}
